import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getinfoFooter = () => {
  return axios.get(`${process.env.API_URL}/footer-info`)
}

